// Asap, il carattere del sito bigiemme.net, incluso nel pacchetto (nessuna richiesta a Google Fonts)
import '@fontsource/asap/400.css';
import '@fontsource/asap/500.css';
import '@fontsource/asap/700.css';
import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/dist/quasar.css';
import './stile.css';
import { createPinia } from 'pinia';
import { Dialog, Notify, Quasar } from 'quasar';
import italiano from 'quasar/lang/it';
import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { applicaTema, temaAttivo, TEMI } from './tema';

applicaTema(temaAttivo.value);

createApp(App)
  .use(Quasar, {
    plugins: { Notify, Dialog },
    lang: italiano,
    config: {
      // primary, secondary, accent e dark dipendono dallo stile scelto (src/tema.ts)
      brand: { ...TEMI[temaAttivo.value].brand, positive: '#1e7f53', negative: '#b3261e', warning: '#9a6212' },
      notify: { position: 'top', timeout: 4000 },
    },
  })
  .use(createPinia())
  .use(router)
  .mount('#app');
